import 'react';

import DesktopReference from './desktop-reference';

type ReferenceFilterProps = {
  border?: boolean;
  sideBorder?: boolean;
  mainProps?: any;
};

const ReferenceFilter = (
  {
    border,
    mainProps,
    sideBorder,
    ref
  }: ReferenceFilterProps
) => {
  return (
    <DesktopReference
      ref={ref}
      border={border}
      mainProps={mainProps}
      sideBorder={sideBorder}
    />
  );
};

ReferenceFilter.displayName = 'ReferenceFilter';

export default ReferenceFilter;
